<template>
  <transition
    :enter-active-class="$style.enterActive"
    :leave-active-class="$style.leaveActive"
    @before-enter="beforeEnter"
    @enter="enter"
    @after-enter="afterEnter"
    @before-leave="beforeLeave"
    @leave="leave"
    @after-leave="afterLeave"
  >
    <div v-show="open" :class="wrapperClass">
      <slot />
    </div>
  </transition>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    wrapperClass: { type: String, default: '' },
    open: { type: Boolean, required: true },
  },
  methods: {
    /** @param {HTMLElement} element */
    beforeEnter(element) {
      requestAnimationFrame(() => {
        if (!element.style.height) {
          element.style.height = '0px';
        }

        element.style.display = null;
      });
    },
    /** @param {HTMLElement} element */
    enter(element) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          element.style.height = `${element.scrollHeight}px`;
        });
      });
    },
    /** @param {HTMLElement} element */
    afterEnter(element) {
      element.style.height = null;
    },
    /** @param {HTMLElement} element */
    beforeLeave(element) {
      requestAnimationFrame(() => {
        if (!element.style.height) {
          element.style.height = `${element.offsetHeight}px`;
        }
      });
    },
    /** @param {HTMLElement} element */
    leave(element) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          element.style.height = '0px';
        });
      });
    },
    /** @param {HTMLElement} element */
    afterLeave(element) {
      element.style.height = null;
    },
  },
});
</script>

<style lang="scss" module>
.enterActive,
.leaveActive {
  overflow: hidden;
  transition: height 0.3s;
}
</style>
